import { ValueTypeEnum } from './value-type-enum.model';
import { NameDescrVal } from '../../../shared/model/name-descr-val.model';
import { TableJoinTypeEnum } from './table-join-type-enum.model';
import { FormFieldRevenueInfo } from './revenue/form-field-revenue-info.model';

export class FormField {
  public constructor() {
    this.intialize();
  }

  public intialize() {
    this.Id = 0;
    this.FieldName = '';
    this.TableName = '';
    this.DisplayName = '';
    this.ValueType = ValueTypeEnum.none;
    this.DisplayValueType = ValueTypeEnum.none;
    this.AvailableValues = new Array<NameDescrVal>();
    this.DisplayAvailableValues = new Array<NameDescrVal>();
    this.FieldValue = null;
    this.IsSensitive = false;
    this.RevenueInfo = new Array<FormFieldRevenueInfo>();
  }
  public Id: number;
  public FieldName: string;
  public TableName: string;
  public DisplayName: string;
  public ValueType: ValueTypeEnum;
  public DisplayValueType: ValueTypeEnum;
  public AvailableValues: Array<NameDescrVal>;
  public DisplayAvailableValues: Array<NameDescrVal>;
  public FieldValue: any;
  public IsSensitive: boolean;
  public FieldType: any;
  public FieldGroupType: any;
  public PrimaryTableRelationType: TableJoinTypeEnum;
  public RevenueInfo: Array<FormFieldRevenueInfo>;
}
